export class Address {
  public addressId: number;
  public address1: string;
  public address2: string;
  public zip: string;
}
